import { getLastIndex } from 'utils/array';
import { cloneRegexWithExtraFlag } from 'utils/regex';
import { REGEX } from 'utils/constants';
import { isValidLink } from 'utils/link';
import { BaseComment } from './types';

/*
  This implementation should be revised
*/

export function parseCommentText(text: string): (string | JSX.Element)[] {
  const linkRegex = cloneRegexWithExtraFlag(REGEX.LINK, 'g');

  const links: string[] = [];

  const replaced = text.replace(linkRegex, (link) => {
    if (!isValidLink(link)) return link;

    links.push(link);

    const index = getLastIndex(links);

    return `{{{[[[((index_${index}))]]]}}}`;
  });

  const splitRegex = /\{\{\{\[\[\[\(\((index_\d+)\)\)\]\]\]\}\}\}/g;

  const content = replaced
    .split(splitRegex)
    .map((text) => {
      if (!text.startsWith('index_'))
        return text.split('\n').map((text, textIndex) =>
          textIndex ? (
            <>
              <br />
              {text}
            </>
          ) : (
            text
          ),
        );

      const index = text.replace('index_', '');

      const link = links[Number(index)];

      return (
        <a
          className="break-all text-primary transition-colors hover:text-primary-light"
          target="_blank"
          rel="noopener noreferrer"
          href={link}
          key={link}
        >
          {link}
        </a>
      );
    })
    .flat()
    .filter((text, index) => (text === '' && !index ? false : true))
    .map((text, index) => (text === '' ? <br key={`${text}--${index}--new-line`} /> : text));

  return content;
}

export function addCommentContent<Comment extends BaseComment>(
  comment: Comment,
): Comment & { content: (string | JSX.Element)[] } {
  return {
    ...comment,
    content: parseCommentText(comment.text),
  };
}
